import { useReduxState } from 'hooks';

const EditorBlockPageBreak = () => {
  const { messages, theme } = useReduxState();

  return (
    <div className="page-break">
      <div className="content">{messages.blocksPageBreak}</div>

      <style jsx>{`
        .page-break {
          align-items: center;
          color: ${theme.textColorLighter};
          display: flex;
        }
        .page-break::before,
        .page-break::after {
          border-bottom: 2px dashed ${theme.lightGreyDark};
          content: '';
          flex-grow: 1;
          flex-shrink: 1;
          height: 0px;
        }
        .content {
          font-size: 1.4rem;
          margin: 0 15px;
        }
      `}</style>
    </div>
  );
};

export default EditorBlockPageBreak;
